import axios from "axios";
import { getToken } from "./constant";

export const validateAuth = async (payload) => {
    const apiBaseUrl = window?.app_data?.appcmsMain?.apiConfig?.apiBaseUrl;
    let endpoint = `${apiBaseUrl}/v2/identity/auth/verify`;
    const token = await getToken();
    let headers = { 'Authorization': token }
    return axios.get(endpoint,{ headers: headers, params: payload });
}

export const checkIfTveLoggedIn = (user) => {
    let entitlementToken = localStorage.getItem('entitlementToken')
    let entitledUser = JSON.parse(entitlementToken)
    let canAuthenticate = entitledUser?.canAuthenticate || null
    const adobeVersion = window?.app_data?.appcmsPlatform?.tveSettings?.version || "v1"
    if ((canAuthenticate && user?.tveMetadata?.tveUserId) || (adobeVersion === "v2" && user?.tveMetadata?.tveUserId)) {
        return true;
    }

    return false;
}